import React, { useState } from "react";
import Axios from "axios";
import { FaCheck, FaMinus, FaTrash, FaPlus, FaTimes } from "react-icons/fa";
import { Input, Select, AutoComplete } from "antd";
const { Option } = Select;
import { SelectForm } from "../../common/Buttons";
import TextInputModal from "../../common/TextInputModal";
import { useEffect } from "react";
import { meanings_options, warrantly_option } from "../../../helpers/GlobalOptions";

function EditAdditionalItem(props) {
  const [Categories, setCategories] = useState([]);
  const [Brands, setBrands] = useState([]);
  const [Models, setModels] = useState([]);
  useEffect(() => {
    getCategories();
    getBrands();
  }, []);

  let timeout;
  let currentValue;



  function fetch(value, callback) {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }
    currentValue = value;

    function fake() {
      Axios.get(
        `/api/v1/orders/shop_categories_list?&q[title_cont_any]=${value}`
      ).then((d) => {
        if (currentValue === value) {
          const { data } = d;
          const data2 = [];
          data.forEach((r) => {
            data2.push({
              value: r.id,
              title: r.title,
            });
          });
          callback(data);
        }
      });
    }
    timeout = setTimeout(fake, 300);
  }

  const handleSearch = (value) => {
    if (value) {
      fetch(value, (data) => setCategories(data));
    } else {
      setCategories([]);
    }
  };

  const getCategories = () => {
    Axios.get(`/api/v1/orders/shop_categories_list`).then((res) => {
      let data2 = [];
      if (res.data) {
        res.data.forEach((item_each) => {
          data2.push({
            value: item_each.id,
            title: item_each.title,
          });
        });
      }
      setCategories(data2);
    });
  };
  const getBrands = () => {
    Axios.get(`/api/v1/brands`).then((res) => {
      setBrands(res.data);
    });
  };

  useEffect(() => {
    Axios.get(
      `/api/v1/categories/list?q[name_cont]=${props.data.category}`
    ).then((response) => {
      if (response.data.length > 0) {
        let modelsData = [];
        response.data.forEach((item) => {
          item.products.forEach((product) => {
            modelsData.push({ value: product.title });
          });
        });
        setModels(modelsData);
      }
    });
  }, [props.data.category]);

  const onChangeCategory = (e) => {
    props.onChangeContractItem(
      {
        target: {
          name: "category",
          value: e,
        },
      },
      props.index
    );
    props.onChangeContractItem(
      {
        target: {
          name: "manufacturer",
          value: undefined,
        },
      },
      props.index
    );

    props.onChangeContractItem(
      {
        target: {
          name: "model",
          value: undefined,
        },
      },
      props.index
    );
  };
  return (
    <div className="mt-1 p-2" style={{ backgroundColor: "#f8f8f8" }}>
      <div>
        <div className="d-flex justify-content-between mb-2">
          <span className="text-bold">
            {props.data.created_at ? (
              <>
                <FaCheck className="mr-2" title={"Created"} color="green" />
                Editing
              </>
            ) : (
              <>
                <FaTimes className="mr-2" title={"Creating"} color="red" />
                Document good
              </>
            )}
          </span>
          {/* {!props.editable && (
            <FaTrash
              style={{ cursor: "pointer", color: "orange" }}
              onClick={() =>
                props.deleteContractItem(
                  props.index,
                  props.data.created_at,
                  props.data.id
                )
              }
            />
          )} */}
        </div>

        <div className="text-bold my-1">
          Price of the item <span className="orange_color">*</span>
        </div>


        <div className="position-relative">
          <label className="position-absolute input_text">&#8364;</label>
          <Input
            type="number"
            name="product_price"
            placeholder="Enter"
            value={props.data.product_price}
            onChange={(e) => props.onChangeContractItem(e, props.index)}
            disabled={props.editable}
          />
        </div>

        <div className="text-bold my-1">
          Category <span className="orange_color">*</span>
        </div>
        <Select
          showSearch
          placeholder="Select"
          optionFilterProp="children"
          value={props.data.category || undefined}
          size="default"
          style={{ width: "100%" }}
          disabled={props.editable}
          onSearch={handleSearch}
          onChange={(e, arg) => onChangeCategory(e)}
        >
          {Categories.map((item, index) => (
            <Option key={index} value={item.title}>
              {item.title}
            </Option>
          ))}
        </Select>
        <div className="text-bold my-1">
          Manufacturer <span className="orange_color">*</span>
        </div>
        <Select
          showSearch
          placeholder="Select"
          optionFilterProp="children"
          value={props.data.manufacturer || undefined}
          size="default"
          style={{ width: "100%" }}
          disabled={props.editable}
          onSearch={handleSearch}
          onChange={(e) => {
            props.onChangeContractItem(
              {
                target: {
                  name: "manufacturer",
                  value: e,
                },
              },
              props.index
            );
          }}
        >
          {Brands.map((item, index) => (
            <Option key={index} value={item.title}>
              {item.title}
            </Option>
          ))}
        </Select>

        <div className="text-bold my-1">
          Model <span className="orange_color">*</span>
        </div>
        <AutoComplete
          style={{ width: "100%" }}
          options={Models}
          value={props.data.model || undefined}
          onChange={(e) => {
            props.onChangeContractItem(
              {
                target: {
                  name: "model",
                  value: e,
                },
              },
              props.index
            );
          }}
          placeholder="Type in"
          disabled={props.editable}
          filterOption={(inputValue, option) => {
            if (!!option && !!inputValue && option.value !== null) {
              return (
                option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !==
                -1
              );
            }
          }}
        />

        <div className="text-bold my-1">
          Manufacturer's warranty:
          <span className="orange_color">*</span>
        </div>
        <SelectForm
          onlyPlaceholder="Select"
          options={warrantly_option}
          value={props.warrantlyValue || undefined}
          onChange={(e) => {
            props.onChangeContract(e, "warranty");
          }}
          disabled={props.editable}
        />
        <TextInputModal
          required="true"
          name="id_number"
          // type="number"
          text="Serial number"
          placeholder="Enter"
          value={props.data.id_number}
          onChange={(e) => props.onChangeContractItem(e, props.index)}
          disabled={props.editable}
        />
        <>
          <div className="text-bold my-1 d-flex justify-content-between">
            <div>
              Additional information <span className="orange_color">*</span>
            </div>
            <div>
              <FaPlus
                style={{ color: "green", cursor: "pointer" }}
                onClick={() => props.addAdditionalItem(props.index)}
              />
            </div>
          </div>
          {props.data.additional_data &&
            props.data.additional_data.map((item, itemIndex) => {
              return (
                <div className="d-flex" key={itemIndex}>
                  <div style={{ width: "45%" }}>
                    <SelectForm
                      onlyPlaceholder="Title"
                      name="key"
                      options={meanings_options}
                      value={item.key}
                      disabled={props.editable}
                      onChange={(e) =>
                        props.changeAdditionalItem(
                          props.index,
                          itemIndex,
                          e,
                          "key"
                        )
                      }
                    />
                  </div>
                  <div style={{ width: "45%" }}>
                    <Input
                      className="orange"
                      name="text"
                      placeholder="Meaning"
                      value={item.text}
                      disabled={props.editable || item.key === null}
                      onChange={(e) =>
                        props.changeAdditionalItem(
                          props.index,
                          itemIndex,
                          e.target.value,
                          "text"
                        )
                      }
                    />
                  </div>
                  <div
                    style={{
                      width: "10%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <FaMinus
                      style={{ color: "red", cursor: "pointer" }}
                      onClick={() =>
                        props.removeAdditionalItem(props.index, itemIndex)
                      }
                    />
                  </div>
                </div>
              );
            })}
        </>
        <label className="text-bold my-1">
          The price of the plan:
          <span className="orange_color">*</span>
        </label>
        <div className="d-flex">
          <div
            className="d-flex align-items-center pr-2"
            style={{ width: "40%" }}
          >
            <div className="position-relative">
              <label className="position-absolute input_text">&#8364;</label>
              <Input
                type="number"
                name="item_price"
                placeholder="Type in"
                value={props.data.item_price}
                disabled={props.editable}
                onChange={(e) => props.onChangeContractItem(e, props.index)}
              />
            </div>
          </div>
          <div
            className="text-bold"
            style={{
              display: "flex",
              alignItems: "center",
              width: "35%",
            }}
          >
            <div className="position-relative">
              <label className="position-absolute input_text">%</label>
              <Input
                type="number"
                name="item_pricePerc"
                placeholder="Type in"
                value={props.data.item_pricePerc}
                disabled={props.editable}
                onChange={(e) => props.onChangeContractItem(e, props.index)}
              />
            </div>
          </div>
          <div
            className="d-flex justify-content-center align-items-center text-secondary"
            style={{ width: "25%" }}
          >
            <span>from the price of the goods</span>
          </div>
        </div>
        <label className="text-bold my-1">Discount</label>
        <div className="d-flex">
          <div
            className="d-flex align-items-center pr-2"
            style={{ width: "40%" }}
          >
            <div className="position-relative">
              <label className="position-absolute input_text">&#8364;</label>
              <Input
                type="number"
                name="item_discount"
                placeholder="Type in"
                value={props.data.item_discount}
                onChange={(e) => props.onChangeContractItem(e, props.index)}
                disabled={props.editable}
              />
            </div>
          </div>
          <div
            className="text-secondary"
            style={{
              display: "flex",
              alignItems: "center",
              width: "60%",
            }}
          >
            Price after discount, {props.data.item_total} &#8364;
          </div>
        </div>
      </div>
    </div>
  );
}
export default EditAdditionalItem;
